import { gql } from "@apollo/client"
import { RegisterSystemTask } from "event-definitions"
import { createEvent } from "library/local-events/index.mjs"
import { replaceAllWith } from "lib/@components/slot/replace-all-with"
import { Frag } from "lib/@components/slot/frag"
import { mutate } from "lib/graphql/mutate"
import { TaskEditor } from "slot-definitions"

const CleanupRedis = createEvent("cleanupRedis")

RegisterSystemTask.handleOnce(({ tasks }) => {
    const task = {
        name: "Cleanup Redis",
        event: CleanupRedis.eventName,
        params: {},
    }
    tasks.push(task)
})
TaskEditor(CleanupRedis.eventName).plug(replaceAllWith(<Frag />))
CleanupRedis.handleOnce(async () => {
    console.log("Cleanup REdis")
    await mutate(
        gql`
            mutation Cleanup {
                cleanupRedis
            }
        `,
        {},
        { returns: "cleanupRedis" }
    )
})
